import { createFileRoute } from '@tanstack/react-router'

import { TermsAndPoliciesAgreement } from '@/containers/TermsAndPoliciesAgreement'

export const Route = createFileRoute('/_unauthenticated/setup/terms-agreement')(
  {
    component: TermsAndPoliciesAgreement,
  }
)
